import React, { useState, useEffect } from "react";
import { getLoggedInUser, getMyOrgDocuments, uploadMyDocument } from "../../utils/helper";
import Loader from "../../utils/Loader";
import avatar from "../../assets/img/profile_av.jpg";
import { alertSuccess, alertError } from "../../utils/alerts";

const INIT_DETAILS = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    status: "",
    address: "",
    marital_status: "single",
    branch: "",
    organization: "",
    department: "",
    staff_id: "",
    hire_date: "",
    job_role: "",
    documents: [],
};

export default function MyOnboarding() {    
    const [loading, setLoading] = useState(false);
    const TOKEN = localStorage.getItem("kloka:token:data");
    const [profile, setEmployee] = useState(null);
    const [details, setDetails] = useState(INIT_DETAILS);
    const [documents, setDocuments] = useState('');
    const [state, setState] = useState('');
    const [document, setDocumentFile] = useState("");

    useEffect(() => {
        setLoading(true)
        getLoggedInUser(TOKEN)
            .then((res) => { 
                setEmployee(res.data.data); setLoading(false) }
            ).catch((err) => { 
                console.log(err.response); setLoading(false); }
            );
    }, [TOKEN]);

    useEffect(() => {
        getMyOrgDocuments()
            .then((res) => { 
                if(res.data.success){
                    setDocuments(res.data.data);  
                }
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    useEffect(() => {
        if(document){
            setState((prev) => ({
                ...prev,
                document: document,
            }));
        }
    }, [document]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setDetails((prev) => ({
            ...prev,
            id: (profile && profile._id) || "",
            first_name: (profile && profile.first_name) || "",
            last_name: (profile && profile.last_name) || "",
            middle_name: (profile && profile.middle_name) || "",
            status: (profile && profile.status) || "",
            email: (profile && profile.email) || "",
            phone: (profile && profile.phone) || "",
            profile_pic: (profile && profile.profile_pic) || "",
            organization: (profile && profile.organization) || "",
            branch: (profile && profile.branch) || "",
            department: (profile && profile.department) || "",
            staff_id: (profile && profile.staff_id) || "",
            job_role: (profile && profile.job_role) || "",
            hire_date: (profile && profile.hire_date) || "",
            hire_month: (profile && profile.hire_month) || "",
            hire_year: (profile && profile.hire_year) || "",
            documents: (profile && profile.documents) || [],
        }));
    }, [profile]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            if(state.document && state.document_id){
                setLoading(true);
                uploadMyDocument(state)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Document upload was canceled!");}
    }

    const isCanEdit = profile && details ? profile.status && ((profile.status === "new") || (profile.status === "onboarding")) : false;

    return (
        <>  
            {isCanEdit && (
                <div className="spur-card-menu">
                    <button data-toggle="modal" data-target="#refModal" type="button" className="pull-right btn topbtn btn-primary">UPLOAD</button>
                </div>
            )}
            
            <h1 className="dash-title">Onboarding</h1>

            {loading ? <Loader /> : 
                <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="profile-view">
                                <div className="profile-img-wrap">
                                    <div className="profile-img">
                                        <img 
                                            src={(details && (details.profile_pic !== "")) ? details.profile_pic : avatar} 
                                            alt="avatar" 
                                        />
                                    </div>
                                </div>
                            
                                <div className="profile-basic">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="profile-info-left">
                                                <h3 className="user-name m-t-0 mb-0 text-capitalize">{details.first_name} {details.last_name} </h3>
                                                <h6 className="text-muted">{details.job_role && details.job_role?.name}</h6>
                                                <small className="text-muted"></small>
                                                <div className="staff-id">Department: {details.department && details.department?.name}</div>
                                                <div className="staff-id">Employee ID: {details.staff_id ? details.staff_id : "KR-FT-1009"} </div>
                                                <div className="staff-id small doj text-muted">Hire Year: {details.hire_year ? details.hire_year 
                                                : "2024"} </div>
                                                <div className="staff-id small doj text-muted">Hire Month: {details.hire_month ? details.hire_month 
                                                : "January"} </div>
                                                <div className="staff-id small doj text-muted">Hire Date: {details.hire_date ? details.hire_date 
                                                : "1st"} </div>
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <ul className="personal-info">
                                                <li>
                                                    <div className="title">Organization:</div>
                                                    <div className="text">{details.organization && details.organization?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Phone:</div>
                                                    <div className="text"><span>{details.phone} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Email:</div>
                                                    <div className="text"><span>{details.email} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Department:</div>
                                                    <div className="text">{details.department && details.department?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Branch:</div>
                                                    <div className="text">{details.branch && details.branch?.branch_name} </div>
                                                </li>
                                                <li>
                                                    <div className="title">Staff ID:</div>
                                                    <div className="text">{details.staff_id && details.staff_id} </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {(documents && documents) && (
                <>
                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <div className="card profile-box flex-fill mt-3">
                                <div className="card-body">
                                    <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 10}}>
                                        Required Documents 
                                    </h3>
                                    <p>Please upload the following document in order to complete your onboarding process.</p>
                                    {(documents && documents.length > 0) ? 
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-stripped">
                                            <thead><tr><th>SN</th><th>Name</th><th>Description</th><th>View Document</th></tr></thead>
                                            <tbody>
                                                {documents && documents.map((row, i)=> (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{row.document_name && row.document_name}</td>
                                                        <td>{row.document_desc && row.document_desc}</td>
                                                        <td><a href={row.document_url} 
                                                        download className="btn btn-view"><i className="fa fa-download"></i> Download Document</a></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div> : <div className="alert alert-danger myerror d-block">No document found.</div> }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {(profile && profile.documents) && (
                <>
                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <div className="card profile-box flex-fill mt-3">
                                <div className="card-body">
                                    <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                        Your Documents 
                                    </h3>
                                    {(profile.documents && profile.documents.length > 0) ? 
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-stripped">
                                            <thead><tr><th>SN</th><th>Document</th><th>View Document</th></tr></thead>
                                            <tbody>
                                                {profile.documents && profile.documents.map((row, i)=> (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{row.document_id?.document_name && row.document_id?.document_name}</td>
                                                        <td><a href={row.document} target="_blank" rel="noreferrer"
                                                            className="btn btn-view"><i className="fa fa-download"></i> View Document</a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div> : <div className="alert alert-danger myerror d-block">No document found.</div> }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <div id="refModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">COMPLETE YOUR DOCUMENTATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Select Onboarding Document <span>*</span></label>
                                    <select className="form-control form-select" name="document_id" id="document_id" required 
                                        onChange={handleChange}>
                                        <option value=''>Select Document</option>
                                        {documents && documents.map((mate, i) => (
                                            <option key={i} value={mate._id}>{mate.document_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Document <span>*</span></label>
                                    <input type="file" name="document" className="form-control" required placeholder="file" 
                                    onChange={(e) => {setDocumentFile(e.target.files[0]);}} disabled={loading} />
                                </div>
                            </div>
                            {isCanEdit && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdate} >Upload Document</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 


            </> }
        </>
    );
}
